import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Box from "@mui/material/Box";
import CircularProgress from '@mui/material/CircularProgress';

// Components
import Imprest from './imprest';

// Hooks
import useUser from '../../../../../hooks/user/useUser';

// Models
import { cashRegisterMovementModel, movementTypes, cashTypes, subTypes, subTypesFormat } from "../../../../../models/CashRegisterMovementEntity";

// Services 
import CashRegisterService from '../../../../../services/cashRegisterService';
import FileService from '../../../../../services/fileService';

const CreateEgressModal = ({ onClose, onSave, open, cashRegister, monthlyImprest }) => {
    const [loading, setLoading] = useState(false);
    const { email, pv } = useUser();

    const [movement, setMovement] = useState({
        ...cashRegisterMovementModel,
        type: movementTypes.egress,
        cashType: cashTypes.cash,
        subType: subTypes.Imprest,
        cashRegisterId: cashRegister?.id,
        cashRegisterName: cashRegister?.name
    });

    useEffect(() => {
        if (email && pv) {
            setMovement(state => ({
                ...state,
                userEmail: email,
                billingCode: pv.billingCode
            }))
        }
    }, [email, pv]);

    const handleSave = async () => {
        setLoading(true);
        try {
            const req = {
                ...movement,
                amount: Number(movement.amount)
            }
            if (req.files.length > 0) {
                const fileUrl = await FileService.Upload(req.files[0]);
                delete req.files;
                req.fileUrl = fileUrl;
            }

            await CashRegisterService.CreateMovement(req);
        } catch (err) {
            console.error(err)
        }
        onSave();
        setLoading(false);
    }

    const disableSave = () => {
        return (
            !movement.reasonId ||
            movement.amount <= 0 ||
            movement.files.length === 0 ||
            (monthlyImprest.fixedAmount - movement.amount) < 0 ||
            (monthlyImprest?.totalAmountImprest - movement.amount) < 0
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={!movement.subType ? 'xs' : 'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                Egreso de Caja
                <Grid container spacing={1}>
                    {cashRegister && cashRegister.name &&
                        <Grid size={6}>
                            <Box display="flex" justifyContent='flex-start'>
                                <Typography color="primary" variant="body1" gutterBottom>
                                    Caja seleccionada:&nbsp;
                                </Typography>
                                <Typography variant="body1">
                                    <strong>
                                        {cashRegister.name}
                                    </strong>
                                </Typography>
                            </Box>
                        </Grid>
                    }
                    {movement && movement.subType &&
                        <Grid size={6}>
                            <Box display="flex" justifyContent='flex-end'>
                                <Typography color="primary" variant="body1" gutterBottom>
                                    Tipo de movimiento:&nbsp;
                                </Typography>
                                <Typography variant="body1">
                                    <strong>
                                        {subTypesFormat[movement.subType]}
                                    </strong>
                                </Typography>
                            </Box>
                        </Grid>
                    }
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Imprest
                    movement={movement}
                    setMovement={setMovement}
                    totals={monthlyImprest?.totalAmountImprest || 0}
                    fixedAmount={monthlyImprest?.fixedAmount || 0}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Cancelar
                </Button>
                {
                    movement.subType &&
                    <Button
                        onClick={handleSave}
                        color="primary"
                        variant="outlined"
                        autoFocus
                        disabled={disableSave() || loading}
                    >
                        {loading
                            ? <Box display="flex" flexDirection='row' alignItems='center' gap={1}><CircularProgress size={18} /> ...Guardando</Box>
                            : 'Guardar'
                        }
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
}

CreateEgressModal.defaultProps = {
    onSave: () => { },
    onClose: () => { },
}

CreateEgressModal.prototype = {
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    cashRegister: PropTypes.object
}

export default CreateEgressModal;